import React from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function ApplyToAllButtonWithConfirm(props: {
  disabled?: boolean;
  dialogTitle: string;
  dialogDescription: string;
  buttonLabel?: string;
  confirmLabel?: string;
  onConfirm: () => Promise<void>;
}) {
  const {
    disabled = false,
    dialogTitle,
    dialogDescription,
    buttonLabel = "Apply to all",
    confirmLabel = "Apply to all",
    onConfirm,
  } = props;

  const [open, setOpen] = React.useState(false);
  const [applying, setApplying] = React.useState(false);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <Button type="button" variant="outline" size="sm" disabled={disabled || applying} onClick={() => setOpen(true)}>
        {buttonLabel}
      </Button>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{dialogTitle}</AlertDialogTitle>
          <AlertDialogDescription>{dialogDescription}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={applying}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={applying}
            onClick={async (e) => {
              e.preventDefault();
              try {
                setApplying(true);
                await onConfirm();
                setOpen(false);
              } finally {
                setApplying(false);
              }
            }}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

